var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useUniqID } from '../_internal/useUniqId';
import { withLabel } from '../withLabel';
import { Input, FakeInputContainer, FakeInput, CheckIcon, } from './Checkbox.style';
var InnerCheckbox = React.forwardRef(function (props, ref) {
    var error = props.error, disabled = props.disabled, _a = props.small, small = _a === void 0 ? false : _a, rawId = props.id, checked = props.checked, value = props.value, rest = __rest(props, ["error", "disabled", "small", "id", "checked", "value"]);
    var id = useUniqID(rawId);
    return (React.createElement(FakeInputContainer, null,
        React.createElement(Input, __assign({ ref: ref, "data-testid": "checkbox-input" }, rest, { checked: checked !== null && checked !== void 0 ? checked : Boolean(value), "data-error": error, "data-small": small, disabled: disabled, type: "checkbox", id: id })),
        React.createElement(FakeInput, { tabIndex: disabled ? undefined : 0, htmlFor: id },
            React.createElement(CheckIcon, { icon: "check" }))));
});
export var Checkbox = withLabel({
    orientation: 'horizontal-reverse',
    componentName: 'checkbox',
})(InnerCheckbox);
//# sourceMappingURL=Checkbox.js.map